import i18next from '../../../i18next.Config';

// Global i18next instance for code that runs outside React components.
export const translate = (key: string, options?: Record<string, unknown>) =>
  i18next.t(key, options);
